<template>
	<div v-if="currentUser && currentUser.id" id="app">
		<app-header></app-header>
		<router-view />
	</div>
</template>

<script>
import AppHeader from "./Header.vue";

export default {
	name: "DailyDataLayout",
	components: { AppHeader },
	computed: {
		body() {
			return document.getElementsByTagName("body")[0];
		}
	},
	mounted() {
		this.body.classList.add("has-navbar-fixed-top");
	},
	destroyed() {
		this.body.classList.remove("has-navbar-fixed-top");
	}
};
</script>

<style lang="scss">
@import "../scss/styles";
</style>
